import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, CheckCircle } from 'lucide-react';
import { Account } from '../types';

interface SuccessPageProps {
  onContinue?: () => void;
  account?: Account;
}

export const SuccessPage: React.FC<SuccessPageProps> = ({ onContinue }) => {
  const navigate = useNavigate();
  const [planName, setPlanName] = useState('Pro Plan');

  useEffect(() => {
    // Check URL params for plan information
    const urlParams = new URLSearchParams(window.location.search);
    const plan = urlParams.get('plan');
    
    if (plan) {
      setPlanName(plan);
    }
  }, []);

  const handleBack = () => {
    navigate('/');
  };

  return (
    <div className="container mx-auto px-4 py-6 max-w-2xl mt-8">
      {/* Back Button */}
      <div className="mb-6">
        <button
          onClick={handleBack}
          className="btn btn-ghost btn-sm gap-2"
        >
          <ArrowLeft size={16} />
          Back
        </button>
      </div>

      {/* Success Card */}
      <div className="bg-base-100 p-6 md:p-8 rounded-lg border border-base-300">
        {/* Success Icon */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary rounded-full mb-4">
            <CheckCircle className="w-10 h-10 text-white" />
          </div>
          
          <h1 className="text-2xl font-semibold text-base-content mb-2">
            Payment Successful!
          </h1>
          
          <p className="text-base text-base-content/70">
            Thank you for subscribing to {planName}. Your account has been activated.
          </p>
        </div>

        {/* Order Details */}
        <div className="bg-base-200 rounded-lg p-4 mb-6">
          <h3 className="text-base font-semibold text-base-content mb-3">Order Details</h3>
          
          <div className="space-y-2">
            <div className="flex justify-between items-center">
              <span className="text-sm text-base-content/70">Subscription:</span>
              <span className="text-sm font-medium text-base-content">{planName}</span>
            </div>
            
            <div className="flex justify-between items-center">
              <span className="text-sm text-base-content/70">Status:</span>
              <span className="badge badge-success badge-sm text-white">Active</span>
            </div>
            
            <div className="flex justify-between items-center">
              <span className="text-sm text-base-content/70">Date:</span>
              <span className="text-sm font-medium text-base-content">
                {new Date().toLocaleDateString()}
              </span>
            </div>
          </div>
        </div>



        {/* Continue Button */}
        {onContinue && (
          <button
            onClick={onContinue}
            className="btn btn-primary w-full text-white"
          >
            Continue to App
          </button>
        )}
      </div>
    </div>
  );
}; 